import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetosataracabs() {



  const cardData =
  {
    keyword: 'Pune to Satara Cabs',
    heading: 'Sai Trupti Cabs: Pune to Satara Cabs',
    headingDescription: 'Sai Trupti Cabs offers reliable and comfortable Pune to Satara cab hire services, designed to make your inter-city journey smooth and stress-free. Our fleet includes well-maintained, air-conditioned Sedans, SUVs, and Premium vehicles — all equipped with clean interiors and ample luggage space. Every journey is driven by a professional, background-verified chauffeur who ensures punctual pickup in Pune, courteous service, and safe, smooth driving all the way to Satara. With transparent one-way fares, flexible booking options (one-way or round-trip), and 24×7 customer support, Sai Trupti Cabs makes your travel from Pune to Satara convenient, affordable and worry-free.',

    top: 'Top Places to Visit in Satara with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Kaas Plateau (Valley of Flowers)",
    "description": "The Kaas Plateau, famously known as the 'Valley of Flowers of Maharashtra', is a UNESCO World Natural Heritage Site located about 25 km from Satara. Every monsoon, the plateau bursts into a carpet of vibrant wildflowers — pink balsams, yellow smithias, and purple karvis that transform the landscape into a living rainbow. Misty hills, cool breezes, and glittering lakes make it a paradise for photographers and nature lovers. Walkways through the floral meadows lead to panoramic viewpoints overlooking Satara’s lush valleys. With its fragile ecosystem and dreamy beauty, Kaas offers an ethereal experience that feels straight out of a painting — a jewel in Satara’s crown of nature."
  },
  {
    "title": "Thoseghar Waterfalls",
    "description": "Thoseghar Waterfalls near Satara are among Maharashtra’s most spectacular monsoon sights, cascading from heights of nearly 200 m amid dense green cliffs. The roar of falling water blends with the chorus of birds and wind, creating a thrilling yet soothing atmosphere. Viewing decks and nature trails let visitors soak in the mist and serenity from safe vantage points. During the rainy season, smaller surrounding falls merge into a grand natural symphony. Locals and tourists alike visit to picnic, trek, and witness the unrestrained beauty of the Western Ghats. Thoseghar isn’t just a waterfall — it’s a sensory experience that defines Satara’s wild heart."
  },
  {
    "title": "Sajjangad Fort",
    "description": "Sajjangad Fort, meaning 'Fort of Good People', stands gracefully atop the Sahyadri hills and serves as the final resting place of Saint Samarth Ramdas, the spiritual guru of Chhatrapati Shivaji Maharaj. The fort’s tranquil atmosphere, ancient temples, and stone pathways inspire devotion and peace. Climbing its 200 steps rewards visitors with breathtaking views of the valley and Urmodi Dam below. Pilgrims arrive daily to offer prayers and partake in the free prasad meal served with love by the trust. Sajjangad combines history, spirituality, and nature — a sacred summit where courage and compassion coexist."
  },
  {
    "title": "Ajinkyatara Fort",
    "description": "Perched on one of the seven hills surrounding Satara city, Ajinkyatara Fort commands panoramic views of the town and the Sahyadri range. Built in the 16th century, it once served as a key Maratha stronghold under the rule of Chhatrapati Shahu Maharaj. The fort’s ramparts, bastions, and hidden gateways still echo tales of valor and strategy. A short trek takes visitors through scenic paths dotted with wildflowers and ancient walls. At the top, the cool mountain wind and sweeping vistas make every moment worth the climb. Ajinkyatara is the guardian hill of Satara — a blend of heritage, adventure, and natural splendour."
  },
  {
    "title": "Kas Lake",
    "description": "Nestled near the Kaas Plateau, Kas Lake is a serene freshwater reservoir surrounded by hills and forests. Built in 1875 to supply water to Satara city, it has evolved into a scenic picnic and photography spot. The calm lake reflects the shifting skies and colourful meadows of Kaas during monsoon, creating an otherworldly view. Boating on its still waters offers moments of peace, while the surrounding trails invite leisurely walks amid cool breezes. Birds flutter across the glassy surface as fog drifts in, enhancing the dreamlike atmosphere. Kas Lake is Satara’s mirror of nature — tranquil, reflective, and timeless."
  },
  {
    "title": "Char Bhinti and Natraj Mandir",
    "description": "Char Bhinti, meaning 'Four Walls', is a historical site built during Chhatrapati Shahu’s reign to commemorate Maratha warriors. Located atop a small hill near Satara city, it offers sweeping views and a glimpse into the region’s royal heritage. Nearby stands the beautifully crafted Natraj Mandir, where a striking idol of Lord Shiva in the dancing form of Natraj captivates devotees. The temple’s calm architecture and spiritual energy make it a peaceful retreat for meditation and prayer. Together, Char Bhinti and Natraj Mandir represent Satara’s twin essence — valour and divinity united in stone and silence."
  },
  {
    "title": "Urmodi Dam",
    "description": "Urmodi Dam, built across the Urmodi River near Sajjangad, is one of Satara’s most picturesque water reservoirs. The emerald hills, vast blue expanse, and occasional rainbows create a postcard-perfect scene. It’s a favourite weekend drive destination for locals seeking peace and fresh air. During sunrise and sunset, the sky’s golden hues reflect beautifully over the still waters. Visitors can picnic by the banks, enjoy local snacks, and capture panoramic photographs of the dam surrounded by misty Sahyadris. Urmodi Dam exemplifies Satara’s tranquil countryside and is a hidden gem for nature enthusiasts."
  },
  {
    "title": "Koyna Dam and Koyna Wildlife Sanctuary",
    "description": "Koyna Dam, one of India’s largest hydroelectric projects, lies about 70 km from Satara amid breathtaking natural surroundings. The dam’s massive reservoir, Shivsagar Lake, is encircled by dense forests of the Koyna Wildlife Sanctuary — home to tigers, deer, bison, and countless bird species. Boating on the shimmering waters while mist covers the mountain peaks is a surreal experience. The region’s cool climate and pristine environment make it an ideal getaway for eco-tourists. Koyna’s blend of power, wilderness, and serenity represents the perfect harmony between human innovation and nature’s grandeur."
  },
  {
    "title": "Mahabaleshwar Hill Station",
    "description": "Just 55 km from Satara, Mahabaleshwar is the queen of hill stations in Maharashtra, famed for its lush valleys, strawberry farms, and colonial-era charm. The winding roads, mist-cloaked viewpoints like Arthur’s Seat and Kate’s Point, and boating at Venna Lake make it a year-round attraction. Visitors enjoy horse rides, scenic treks, and sampling freshly made strawberry cream. The ancient Mahabaleshwar Temple and Pratapgad Fort nearby add cultural depth to its natural beauty. For Satara travelers, Mahabaleshwar is the perfect blend of adventure, romance, and refreshment amid rolling hills."
  },
  {
    "title": "Pateshwar Cave Temples",
    "description": "Hidden in the forests about 15 km from Satara, the Pateshwar Caves are a cluster of ancient rock-cut temples dedicated to Lord Shiva. Hundreds of Shiva lingams of varying sizes are scattered around the site, symbolising centuries of devotion. The caves also contain detailed carvings of deities, animals, and mythological motifs. Surrounded by trees and the sound of rustling leaves, it’s an ideal place for meditation and introspection. Pilgrims and trekkers alike are drawn by its quiet, mystical aura. Pateshwar is one of Satara’s spiritual gems — where art, faith, and nature coexist in peaceful harmony."
  }
],



"services": [
  {
    "name": "Pune to Satara Cabs",
    "description": "Book comfortable Pune to Satara cabs for a safe, hassle-free journey. Choose from AC and non-AC vehicles including Sedans, SUVs, and luxury cars. Travel with experienced drivers familiar with long-distance routes, enjoy flexible pickup and drop points, and benefit from transparent pricing. Perfect for family trips, weekend getaways, group travel, or corporate journeys, with easy online booking, instant confirmation, and 24/7 support ensuring a smooth ride."
  },
  {
    "name": "Pune to Satara Taxi Service",
    "description": "Hire a Pune to Satara taxi for a stress-free and scenic journey. Well-maintained vehicles, courteous drivers, and flexible schedules make it ideal for tourists, business travelers, and families. One-way or round-trip options are available with transparent fare policies."
  },
  {
    "name": "Pune to Satara Car Hire",
    "description": "Rent a car from Pune to Satara for personalized and comfortable travel. Choose from Sedans, SUVs, and luxury vehicles with AC/non-AC options. Benefit from professional drivers, luggage assistance, flexible routes, and safe travel. Ideal for families, groups, or business trips seeking convenience and comfort."
  },
  {
    "name": "AC Cab Pune to Satara",
    "description": "Travel comfortably with AC cab service from Pune to Satara. Enjoy clean, air-conditioned vehicles, skilled drivers, flexible pickup points, and smooth, safe travel. Suitable for families, couples, and solo travelers looking for a relaxed long-distance journey."
  },
  {
    "name": "Non AC Cab Pune to Satara",
    "description": "Affordable non-AC cab service from Pune to Satara for budget-conscious travelers. Reliable drivers, well-maintained cars, and flexible pickup/drop points ensure safe, comfortable, and economical travel over long distances."
  },
  {
    "name": "Innova Cab Pune to Satara",
    "description": "Book spacious and comfortable Innova cabs from Pune to Satara. Ideal for families or groups, featuring AC comfort, ample legroom, luggage space, and experienced drivers. Enjoy smooth travel on highways and city roads for a stress-free journey."
  },
  {
    "name": "Ertiga Cab Pune to Satara",
    "description": "Affordable and convenient group travel with Ertiga cabs from Pune to Satara. AC/non-AC options, comfortable seating, luggage space, and professional drivers ensure a safe and enjoyable ride. Perfect for friends, families, or corporate groups."
  },
  {
    "name": "Luxury Cab Pune to Satara",
    "description": "Travel in style with luxury cab services from Pune to Satara. Premium Sedans and SUVs with elegant interiors, AC service, and professional chauffeurs make it ideal for VIP guests, business executives, or special occasions. Experience comfort, safety, and prestige throughout the journey."
  },
  {
    "name": "Affordable Cab Pune to Satara",
    "description": "Get pocket-friendly Pune to Satara cab services with transparent fares, AC/non-AC options, and professional drivers. Flexible timings, easy booking, and reliable service make it perfect for solo travelers, students, and small families looking for value-for-money travel."
  },
  {
    "name": "Pune to Satara Outstation Cab",
    "description": "Reliable outstation cab service from Pune to Satara ideal for weekend trips, sightseeing, or long stays. Choose from a variety of vehicles, enjoy AC/non-AC comfort, flexible bookings, and safe travel with experienced drivers for a hassle-free interstate journey."
  },
  {
    "name": "Pune to Satara One Way Cab",
    "description": "Book one-way cabs from Pune to Satara at affordable rates. Point-to-point travel, clean vehicles, professional drivers, and flexible pickups make it ideal for travelers heading to Satara without return plans."
  },
  {
    "name": "Pune to Satara Drop Cab",
    "description": "One-way drop cab service from Pune to Satara with flexible timings, AC/non-AC options, and professional drivers. Enjoy a smooth, comfortable ride perfect for single transfers, business trips, or leisure travel."
  },
  {
    "name": "Corporate Cab Pune to Satara",
    "description": "Premium corporate cab hire from Pune to Satara with executive vehicles, professional chauffeurs, and flexible travel schedules. Ideal for conferences, business meetings, client visits, and corporate events, offering comfort, punctuality, and reliability."
  },
  {
    "name": "Wedding Cab Pune to Satara",
    "description": "Elegant wedding cab service from Pune to Satara with luxury interiors, AC comfort, professional drivers, and on-time pickups. Perfect for bride/groom transfers, guest transport, and event logistics with complete reliability and style."
  },
  {
    "name": "Online Cab Booking Pune to Satara",
    "description": "Book your Pune to Satara cab online with instant confirmation, secure payment, and transparent fares. Choose from Sedans, Innova, and Ertiga for a convenient, stress-free journey. Ideal for last-minute travel, weekend trips, or planned travel with complete convenience."
  }
],
"tableData": [
  ["Pune to Satara Cabs", "Pune to Satara Taxi Service"],
  ["Pune to Satara Car Hire", "AC Cab Pune to Satara"],
  ["Non AC Cab Pune to Satara", "Innova Cab Pune to Satara"],
  ["Ertiga Cab Pune to Satara", "Luxury Cab Pune to Satara"],
  ["Affordable Cab Pune to Satara", "Pune to Satara Outstation Cab"],
  ["Pune to Satara One Way Cab", "Pune to Satara Drop Cab"],
  ["Online Cab Booking Pune to Satara", "Corporate Cab Pune to Satara"],
  ["Wedding Cab Pune to Satara", ""]
],


"whychoose": [
  {
    "WhyChooseheading": "Pune to Satara Cabs",
    "WhyChoosedescription": "Sai Trupti Cabs offers comfortable and reliable cab services from Pune to Satara — ideal for family travel, business trips, or weekend getaways to the scenic hills of Satara."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Enjoy affordable and transparent fares for Pune to Satara cabs — no hidden costs, no surge pricing, and complete value for your money."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, and premium cars as per your comfort, group size, and budget for the Pune–Satara route."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our courteous and trained drivers are familiar with the Pune to Satara route, ensuring a safe, smooth, and punctual travel experience."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We offer flexible pickups from anywhere in Pune — airport, railway station, home, or office — and drop-offs at your chosen location in Satara."
  },
  {
    "WhyChooseheading": "Clean & Well-Maintained Vehicles",
    "WhyChoosedescription": "Sai Trupti Cabs provides a fleet of clean, sanitized, and regularly maintained vehicles for a comfortable and worry-free journey every time."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to help you with booking, route information, or any travel assistance for your Pune to Satara cab trip."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Book your Pune to Satara cab easily via phone, WhatsApp, or our website — get instant confirmation and timely cab service without any hassle."
  }
]































  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs offer Pune to Satara cab services?',
    answer: 'Yes, Sai Trupti Cabs provides safe, reliable, and affordable Pune to Satara cab services for one way, round trips, and business or personal travel.',
  },
  {
    question: 'How can I book a Pune to Satara cab with Sai Trupti Cabs?',
    answer: 'You can easily book your Pune to Satara cab through our website, mobile app, or by contacting our 24×7 customer support team for instant booking assistance.',
  },
  {
    question: 'What types of cabs are available from Pune to Satara?',
    answer: 'We offer a range of well-maintained vehicles including hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, and tempo travellers—ideal for families, groups, and solo travelers.',
  },
  {
    question: 'Are the drivers experienced for Pune to Satara routes?',
    answer: 'Yes, all our drivers are professional, courteous, and experienced with the Pune–Satara route, ensuring a comfortable and safe travel experience.',
  },
  {
    question: 'Can I book a cab for local sightseeing in and around Satara?',
    answer: 'Of course! Sai Trupti Cabs offers local sightseeing packages in Satara for attractions like Kaas Plateau, Ajinkyatara Fort, Thoseghar Waterfalls, and Sajjangad Fort.',
  },
  {
    question: 'Is the Pune to Satara cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs operates 24×7 Pune to Satara cab services so you can plan your trip anytime according to your convenience.',
  },
  {
    question: 'What are the Pune to Satara cab fares?',
    answer: 'Our Pune to Satara cab fares start from ₹1,800 for sedans and ₹2,500–₹3,200 for SUVs or Innova Crysta, depending on your travel plan and vehicle choice.',
  },
  {
    question: 'What payment options are available for Pune to Satara cab bookings?',
    answer: 'We accept payments via UPI, credit/debit cards, digital wallets, and bank transfers for a seamless and secure transaction experience.',
  },
  {
    question: 'What safety and hygiene measures are followed for Pune to Satara cabs?',
    answer: 'All our cabs are sanitized before each ride, and our drivers follow strict hygiene and safety protocols to ensure a worry-free journey.',
  },
  {
    question: 'Is customer support available during the Pune to Satara cab journey?',
    answer: 'Yes, Sai Trupti Cabs provides round-the-clock customer support to assist you during your Pune to Satara trip.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ramesh Gaikwad',
    feedback: 'Our Pune to Satara trip with Sai Trupti Cabs was excellent. Comfortable car, safe driving, and very professional service.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Sneha Patil',
    feedback: 'Sai Trupti Cabs made our Pune to Satara journey smooth and hassle-free. The driver was courteous and the cab was clean and comfortable.',
    rating: 5,
  },
];




























































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];














const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Pune to Satara Cab Service",
  "image": "https://saitrupticabs.com/assets/images/pune-to-satara-cab.jpg",
  "description": "Sai Trupti Cabs offers Pune to Satara cab service with one way taxi, round trip cabs, sedan, SUV, Ertiga and Innova Crysta options. Book affordable daily outstation cabs with professional drivers, 24x7 service and safe, comfortable travel experience.",
  "provider": {
    "@type": "Organization",
    "name": "Sai Trupti Cabs",
    "url": "https://saitrupticabs.com"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Pune to Satara"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "8450"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1799",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/pune-to-satara-cab-booking",
    "itemCondition": "https://schema.org/NewCondition"
  }
};




  return (
    <div>


<Helmet>
  <title>Pune to Satara Cab Service | One Way Taxi ₹1799 | Sai Trupti Cabs</title>

  <meta 
    name="description" 
    content="Book Pune to Satara cab at best price ₹1799 with Sai Trupti Cabs. One way taxi, round trip, Innova Crysta, Ertiga, sedan & SUV available. Fast, safe and 24x7 cab service for daily travel." 
  />

  <meta 
    name="keywords" 
    content="pune to satara cab, pune to satara taxi, pune to satara cab service, pune to satara one way cab, pune to satara taxi fare, pune to satara innova crysta, pune to satara ertiga cab, pune to satara sedan cab, cheap pune to satara cab, best cab service pune to satara, pune to satara drop taxi, pune to satara round trip cab, outstation cab pune to satara, pune to satara online cab booking" 
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/79.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetosataracabs;